export default __webpack_public_path__ + "static/media/testimonials_bg.727988c1.svg";